import { render, staticRenderFns } from "./CompletionBar.vue?vue&type=template&id=8a384c28"
import script from "./CompletionBar.vue?vue&type=script&lang=js"
export * from "./CompletionBar.vue?vue&type=script&lang=js"
import style0 from "./CompletionBar.vue?vue&type=style&index=0&id=8a384c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports